import React, {Component} from 'react';
import { Form,Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import axios from 'axios';
import _ from 'lodash';

import {
    BACKEND_URL
} from '../../config.js';

class SharingModel extends Component {

      state = {
          bis_client_list: [],
          isLoading: false,
          selected: null,
          bis_id: []

      }

      componentDidMount() {
          this.getReportList()
      }

      onChange =(selected)=> {
          this.setState({selected: selected})
          // if(selected.length > 0) {
          //     this.setState({ bis_id: selected })
          // } else {
          //    this.setState({ bis_id: [] }) 
          // }
      }

      handleSave = ()=> {
          this.props.onSubmit(this.state.selected)
      }

      getReportList = ()=> {
        this.setState({isLoading: true})
        axios.get(
          BACKEND_URL + "/v1/explore/client_list", {
              headers: {
               token: localStorage.getItem("token")
             }
          }
        ).then((res) => {
            let defaultSel = this.props.sharingIds
            let newDefault = []
            if(defaultSel && defaultSel.length > 0) {
                for(let cid of defaultSel) {
                    let x = _.find(res.data, (o)=> o.companyId == cid)
                    if(x) {
                        newDefault.push(x)
                    }
                }
                this.setState({selected: newDefault})
            }
            let uniqData = _.unionBy(res.data, 'companyId');
            this.setState({bis_client_list: uniqData, isLoading: false})

        }).catch((err) => {
            this.setState({isLoading: false})
            alert("Something Went Wrong!")
            console.log(err)
        })
      }
        
    render(){
        return(
            <div>
                {  this.state.isLoading ? <div>Loading List, Please Wait.....</div> :
                    <div>
                        <Typeahead
                          style={{border: '1px solid #ccc', padding: '12px 20px', margin: '8px 0'}}
                          autoFocus={true}
                          placeholder="Please select from list"
                          id="client-bis"
                          multiple
                          labelKey="companyName"
                          onChange={(selected) => this.onChange(selected)}
                          options={this.state.bis_client_list}
                          selected={this.state.selected}
                        />
                        <Button disabled={this.state.bis_id == null} varient="primary" onClick={this.handleSave}>
                                 { 'Update Now' }
                        </Button>
                    </div>
                }
            </div>
        )
    }
} 


export default SharingModel;


// WEBPACK FOOTER //
// ./src/components/SharingModel/SharingModel.jsx